import { LegalNoticeText } from "src/components/LegalNotice";
import { IArticleConfig } from "src/components/LegalNotice/types";

export const PROMOTION_ARTICLES: IArticleConfig[] = [
  {
    title: "Eligibility",
    content: (
      <LegalNoticeText>
        Terminal Sweepstakes (the &ldquo;Sweepstakes&rdquo; or
        &ldquo;Promotion&rdquo;) is open only to legal residents of the fifty
        (50) United States and the District of Columbia, who are at least 18
        years of age or older and legal age of majority in their jurisdiction
        of residence. Inspired Acquisitions, Ltd. (the &ldquo;Sponsor&rdquo;
        and the &ldquo;Administrator&rdquo;), its parent, affiliates,
        subsidiaries, promotion agencies and each of their respective
        directors, officers, employees and assigns (collectively
        &ldquo;Released Parties&rdquo;) and their immediate family members
        and/or those living in the same household of each (whether related
        or not) are not eligible. For purposes of this Promotion, the term
        &ldquo;family member&rdquo; is defined as spouse, partner, parent,
        legal guardian, in-law, grandparent, child, or grandchild. The
        Sweepstakes is subject to all applicable federal, state and local
        laws and regulations. Void where prohibited. Participation
        constitutes entrant&rsquo;s full and unconditional agreement to
        these Official Rules and Sponsor&rsquo;s and Administrator&rsquo;s
        decisions, which are final and binding in all matters related to
        the Sweepstakes. Winning a prize is contingent upon fulfilling all
        requirements set forth herein.
      </LegalNoticeText>
    ),
  },
  {
    title: "Timing",
    content: (
      <LegalNoticeText>
        The Promotion begins on May 27, 2026, ends on August 27, 2026 (the
        &ldquo;Promotion Period&rdquo;). Administrator&rsquo;s computer
        systems is the official time-keeping device for the Sweepstakes.
      </LegalNoticeText>
    ),
  },
  {
    title: "How to Enter",
    content: (
      <>
        <LegalNoticeText>Two methods of entry:</LegalNoticeText>
        <LegalNoticeText>
          <strong>Method 1:</strong> Use the Terminal Platform (the
          &ldquo;Platform&rdquo;) to transact in digital assets. Upon
          completion of the transaction, earn one (1) entry into the
          Sweepstakes. Normal fees apply to transacting on the Platform,
          including third party fees. By transacting on the Platform, you
          agree to the terms of use. If you do not agree to such terms of
          use, you cannot transact on the Platform, and will be ineligible
          to receive a prize. Prizes will be delivered via the method the
          entrant used to transact on the Platform (i.e. to the blockchain
          address used to transact on the Platform).
        </LegalNoticeText>
        <LegalNoticeText>
          <strong>Method 2:</strong> To enter via mail, hand write the
          following on the front of a 3x5 card, your name, address, city,
          state, zip, e-mail address, telephone number, blockchain address
          and date of birth. Insert single card in an envelope and mail
          with sufficient postage to: Terminal Promotions, 224 W 35th St
          Ste 500 #2853, New York, New York 10001 &ndash; return address
          and mailing address on envelope must be handwritten. Mail-in
          entries must include all requested information (as stated above)
          to be considered an entry. Mail-in entries must be postmarked
          during the Promotion Period. Earn one (1) entry per
          postcard/envelope. Requests for confirmation of receipt of
          mail-in entries will not be acknowledged. No photo copies,
          facsimiles or reproductions of mail-in entry will be accepted.
          Sponsor is not responsible for late, lost, damaged, stolen,
          incomplete, illegible, postage due, or misdirected entries. Proof
          of mailing does not constitute proof of delivery. In order to
          receive a prize for the Promotion, winners using Method 2 must
          connect to the Platform using a blockchain address which can
          transact on the Platform.
        </LegalNoticeText>
        <LegalNoticeText>
          <strong>Note:</strong> Entering by transacting on the Platform
          during the Promotion Period will not help you win. Your chances of
          winning are the same regardless of method of entry.
        </LegalNoticeText>
        <LegalNoticeText>
          <strong>Note:</strong> To claim a prize in this Sweepstakes, all
          potential winners will be required to connect a wallet to the
          Platform. Connecting a wallet to the Platform requires that a
          participant agree to all site Terms and Conditions. ALL POTENTIAL
          WINNERS ARE SUBJECT TO VERIFICATION BY SPONSOR, WHOSE DECISIONS
          ARE FINAL AND BINDING. A PARTICIPANT IS NOT A WINNER OF ANY PRIZE
          UNLESS AND UNTIL THAT PARTICIPANT&rsquo;S ELIGIBILITY AND
          COMPLIANCE WITH ALL REQUIREMENTS TO CLAIM A PRIZE HAVE BEEN
          VERIFIED AND FULFILLED, AND THE PARTICIPANT HAS BEEN NOTIFIED
          THAT VERIFICATION IS COMPLETE.
        </LegalNoticeText>
        <LegalNoticeText>
          Participants must comply with these Official Rules and the
          Conditions of Entry. Determination of compliance will be in the
          sole discretion of the Sponsor/Administrator.
        </LegalNoticeText>
        <LegalNoticeText>
          <strong>Limit:</strong> Limit one entry per person/email address
          no matter the means of entry. Entries received from any person in
          excess of the stated limitation will be void, and that person may
          be disqualified from entry and/or winning. Entries received from
          any person who attempts to cancel and create a new account, or
          who attempts to create an additional account, during the
          promotion period will be disqualified. Any attempt by any entrant
          to obtain more than the stated number of entries by using
          multiple/different email addresses or any other methods will void
          that entrant&rsquo;s entries and that entrant may be disqualified.
          Use of any automated system to participate is prohibited and will
          result in disqualification.
        </LegalNoticeText>
      </>
    ),
  },
  {
    title: "Drawings",
    content: (
      <LegalNoticeText>
        Winners will be randomly selected at the time of transacting on the
        Platform or receipt of the entrant post card. Limit one prize per
        person/household in this Promotion.
      </LegalNoticeText>
    ),
  },
  {
    title: "Winner Notification",
    content: (
      <LegalNoticeText>
        Winners using Method 1 will be notified that they have won at the
        time of the Promotion. Winners using Method 2 will be notified
        within 90 days of their submission if they have won.
      </LegalNoticeText>
    ),
  },
  {
    title: "Prizes",
    content: (
      <LegalNoticeText>
        Prizes will be awarded in stablecoins or other digital asset. No
        prize shall be worth more than $500. Prizes are non-transferable and
        no substitution will be made except as provided herein at the
        Sponsor&rsquo;s sole discretion. Sponsor reserves the right where
        lawful to substitute a prize for one of equal or greater value if
        the designated prize should become unavailable for any reason.
        Prizes consist of only the items specifically listed as part of the
        prize. In no event will more than the stated number of prizes be
        awarded. Winners are solely responsible for any/all applicable
        federal, state and local taxes and any other expenses related to
        the acceptance and use of a prize not specified herein. Prize
        details not specifically stated in these Official Rules will be
        determined in Sponsor&rsquo;s sole discretion. Sponsor is not
        responsible for, and will not replace, any lost, damaged or stolen
        prize or prize component or any prize that is undeliverable.
        Winners acknowledge that Sponsor is subject to U.S. economic
        restrictions and trade sanctions; as such, Sponsor reserves the
        right to deny distribution of any prize when required by applicable
        law. Participants waive the right to assert as a cost of winning a
        prize, any costs associated with claiming or seeking to claim a
        prize, or using a prize.
      </LegalNoticeText>
    ),
  },
  {
    title: "Taxes",
    content: (
      <LegalNoticeText>
        Each winner is solely responsible for reporting and paying any and
        all applicable taxes related to the prize(s). Each winner will be
        subject to an onboarding verification process and is required to
        provide any requested tax reporting information before any prize is
        awarded including name, date of birth, address, phone numbers and
        social security number or taxpayer identification number. The value
        of any prize awarded to a winner will be reported for tax purposes
        as required by law. Any person receiving at least six hundred
        dollars (USD600) from the Sponsor will receive an IRS Form 1099 at
        the end of the calendar year and a copy of such form will be filed
        with the IRS. Each winner is required to notify the Sponsor if any
        information provided hereunder changes, including the winner&rsquo;s
        address. Potential winner should consult an accountant or tax
        professional to determine tax implications in accepting and using
        (including conducting transactions of) any Prize.
      </LegalNoticeText>
    ),
  },
  {
    title: "Release",
    content: (
      <LegalNoticeText>
        Entrants/winners agree to release, discharge and hold harmless
        Released Parties from and against any claim or cause of action or
        liability (including but not limited to, personal injury, death or
        damage to or loss of property as well as claims based on publicity
        rights, defamation and/or invasion of privacy) arising out of or in
        connection with participation in the Sweepstakes or
        acceptance/receipt/use or misuse of any prize, and agree to be
        bound by the Official Rules and the decisions of the Sponsor, the
        Administrator and/or Sponsor&rsquo;s representatives, which are
        final. Acceptance of a prize constitutes permission for the Sponsor
        and its agencies to use winner&rsquo;s name, likeness, photograph
        and/or hometown and state for purposes of complying with
        obligations as described in Section 11 below, and for advertising
        and trade without further compensation, in any media, worldwide,
        unless prohibited by law.
      </LegalNoticeText>
    ),
  },
  {
    title: "General",
    content: (
      <>
        <LegalNoticeText>
          ANY ATTEMPT BY AN INDIVIDUAL TO DELIBERATELY UNDERMINE THE
          LEGITIMATE OPERATION OF THIS PROMOTION IS A VIOLATION OF CRIMINAL
          AND CIVIL LAWS, AND SHOULD SUCH AN ATTEMPT BE MADE, SPONSOR
          RESERVES THE RIGHT TO SEEK DAMAGES FROM ANY SUCH INDIVIDUAL TO
          THE FULLEST EXTENT PERMITTED BY LAW.
        </LegalNoticeText>
        <LegalNoticeText>
          Sponsor will not be responsible for lost, late, damaged,
          misdirected or mutilated mail, misdirected email, or for any
          technical problems, faulty, lost, garbled, incomplete, incorrect
          or mistranscribed data transmissions, incorrect announcements of
          any kind, malfunctions, technical hardware or software failures
          of any kind including any injury or damage to any person&rsquo;s
          computer/mobile device related to or resulting from participating
          in or experiencing any materials in connection with this
          Promotion.
        </LegalNoticeText>
        <LegalNoticeText>
          Sponsor is not responsible for malfunctions or breakdown of any
          network systems, unavailable service connections, lost,
          incomplete, faulty network connectivity of any kind, failures of
          any service providers, or any combination thereof, which may
          limit a person&rsquo;s ability to participate in this Promotion.
        </LegalNoticeText>
        <LegalNoticeText>
          Sponsor reserves the right to suspend, cancel or modify the
          Promotion if it cannot be executed as planned for any reason
          including, but not limited to, if there is human error, technical
          failures, or any other factor impairs the integrity or proper
          functioning of the Promotion; or if a virus, bug or other
          technical problem corrupts the administration, security, or
          proper play of the Promotion as determined by Sponsor in its sole
          discretion. If the Promotion is so cancelled or modified, Sponsor
          may award prizes from among all eligible participants prior to
          such action and Sponsor shall have no further obligation to any
          participant in connection with this Promotion. Sponsor reserves
          the right to prohibit the participation of an individual if
          tampering is suspected or if the participant fails to comply with
          any requirement of participation as stated herein or with any
          provision in these Official Rules.
        </LegalNoticeText>
        <LegalNoticeText>
          In the event there is a discrepancy or inconsistency between
          disclosures or other statements contained in promotional
          materials and the terms and conditions of the Official Rules, the
          Official Rules shall prevail, govern and control. Sponsor will
          not be responsible for any typographical or other error in the
          printing of the offer, administration of the Sweepstakes or in
          the announcement of the prizes.
        </LegalNoticeText>
      </>
    ),
  },
  {
    title: "Disputes",
    content: (
      <>
        <LegalNoticeText>
          All federal, state and local laws and regulations apply. ALL
          DISPUTES REGARDING THIS PROMOTION SHALL BE DECIDED BY BINDING
          ARBITRATION IN WILMINGTON, DE USING THE AAA COMMERCIAL
          ARBITRATION RULES. Claims may not be resolved through any form of
          class action.
        </LegalNoticeText>
        <LegalNoticeText>
          Entrant agrees that any and all claims, judgments, and awards
          shall be limited to the lower of either reasonable or actual out
          of pocket costs incurred, including any costs associated with
          participation in this Promotion but in no event attorneys&rsquo;
          fees; and under no circumstances will entrants/winners be
          permitted to obtain awards for and entrants/winners hereby waive
          all rights to claim punitive, incidental and consequential
          damages and any other damages, other than for the lower of either
          reasonable or actual out-of-pocket expenses and any and all
          rights to have damages multiplied or otherwise increased.
        </LegalNoticeText>
        <LegalNoticeText>
          SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OR EXCLUSION OF
          LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE
          MAY NOT APPLY TO YOU.
        </LegalNoticeText>
        <LegalNoticeText>
          In addition to the tax liability disclosures in these Rules,
          winners are subject to abide by the income reporting and, if
          applicable, the payment of any taxes due per the laws, rules and
          regulations of the winner&rsquo;s state of residence.
        </LegalNoticeText>
        <LegalNoticeText>
          By entering and participating in the Promotion, Entrants hereby
          expressly agree and accept that for all that is related to the
          interpretation, performance and enforcement of these Official
          Rules, each of them expressly submit themselves to the laws of
          the United States of America and the State of Delaware, expressly
          waiving to any other jurisdiction that could correspond to them
          by virtue of their present or future domicile or by virtue of any
          other cause.
        </LegalNoticeText>
      </>
    ),
  },
];
